import { FC } from 'react'
import s from './List.module.sass'
import { Template } from '@widgets/Restaurant/RestCards/RestCard/ui/CardTypes/Template'
import { TemplateCardProps } from '@widgets/Restaurant/RestCards/RestCard/type/TemplateCardProps'
import TypeAndPrice from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice/TypeAndPrice'
import { Place, PlaceSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/Place'
import {
  ScheduleAndPrice,
  ScheduleAndPriceSkeleton,
} from '@widgets/Restaurant/RestCards/RestCard/ui/Components/ScheduleAndPrice'
import { useCurrentSize } from '@shared/lib/helpers/classes'
import { BlockBoundary } from '@shared/lib/components/BlockBoundary'
import { PromoBadgeLabel } from '@shared/ui/Feedback/PromoBadges/PromoBadgeLabel'
import { TypeAndPriceSkeleton } from '@widgets/Restaurant/RestCards/RestCard/ui/Components/TypeAndPrice'

const List: FC<TemplateCardProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (
  props,
) => {
  const [size] = useCurrentSize(props.sizes)

  const price = props.data.price
  const metro = props.data.address?.metro
  const address = props.data.address?.address
  const isOptimizeData = [1, 2].includes(props.data.optimizationState)

  const TypeAndPriceComponent = () => {
    return isOptimizeData ? (
      <TypeAndPriceSkeleton />
    ) : (
      <TypeAndPrice
        restType={props.data.type}
        priceRange={size !== 'S' ? price.level : null}
        priceLink={price.tag.url}
      />
    )
  }

  const PlaceComponent = () => {
    return isOptimizeData ? <PlaceSkeleton /> : <Place address={address} metro={metro} />
  }

  const ScheduleAndPriceComponent = () => {
    return isOptimizeData ? (
      <ScheduleAndPriceSkeleton />
    ) : (
      <ScheduleAndPrice
        schedule={props.data.schedule}
        priceRange={size === 'S' ? price.level : null}
        priceLink={price.tag.url}
      />
    )
  }

  return (
    <BlockBoundary>
      <Template {...props}>
        {!isOptimizeData && !!props.data.discounts.remarked && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.remarked}₽
          </PromoBadgeLabel>
        )}

        {!isOptimizeData && !!props.data.discounts.restoplace && (
          <PromoBadgeLabel label={'Скидка'} className={s['promo-label']}>
            -{props.data.discounts.restoplace}₽
          </PromoBadgeLabel>
        )}

        {/* <TastyClub tastyClub={props.data.discounts.tastyclub} /> */}
        <TypeAndPriceComponent />

        {size !== 'S' && <PlaceComponent />}

        <ScheduleAndPriceComponent />

        {size === 'S' && <PlaceComponent />}
      </Template>
    </BlockBoundary>
  )
}

export default List
